import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from "../../hoc/Shared/utility";
import Button from "../../components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import SpareDomainListing from "./SpareDomainListing";
import SpareDomainCreate from "./SpareDomainCreate";

import { getSpareDomainList, deleteSpareDomain } from "../../store/ducks/spareDomain/actions";

const initialFilteringState = {
    domain: ""
};

class SpareDomain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pageShow: "listing",
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',
            data: [],
            filterInput: initialFilteringState,
            detailsParam: {},
            permission: []
        }
    }

    componentDidMount() {
        const data = this.fetchData();
        this.props.getSpareDomainList(data);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            this.setState({ permission: this.props.currentPermission });
        }

        if (nextProps.spare_domain_list !== undefined && nextProps.spare_domain_list !== this.props.spare_domain_list) {
            if (nextProps.spare_domain_list.responseCode === 200 && nextProps.spare_domain_list.msgType === "success") {
                this.setState({
                    data: nextProps.spare_domain_list.data.result.row,
                    totalRecords: nextProps.spare_domain_list.data.result.pagination.total_record,
                    loading: false
                });
            }
            else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0
                }, () => {
                    filterErrorHandler(nextProps.spare_domain_list.message);
                });
            }
        }

        if (nextProps.spare_domain_delete !== undefined && nextProps.spare_domain_delete !== this.props.spare_domain_delete) {
            if (nextProps.spare_domain_delete.responseCode === 200 && nextProps.spare_domain_delete.msgType === 'success') {
                const { t } = this.props;
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.refreshHandler();
                    }
                });
            }
            else {
                filterErrorHandler(nextProps.spare_domain_delete.message);
            }
        }

        return true;
    }

    fetchData = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage });
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        Object.keys(this.state.filterInput).forEach((val) => {
            listingArr[val] = ((val === 'start_date' || val === 'end_date') && this.state.filterInput[val] !== '') ? moment(this.state.filterInput[val]).format("YYYY-MM-DD") : this.state.filterInput[val];
        });

        return listingArr;
    }

    onInputChange(event) {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filterInput);
        if (event.target.id === 'transaction_date') {
            const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
            newFilter['date'] = event.target.value;
        }
        else {
            newFilter[event.target.id] = event.target.value;
        }
        this.setState({
            filterInput: newFilter
        });
    }

    clearHandler = () => {
        let newFilter = initialFilteringState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            searchValue: '',
            order: '',
            filterInput: newFilter,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSpareDomainList(listingArr);
        });
    }

    refreshHandler = () => {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: '',
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSpareDomainList(listingArr);
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page,
        });
    }

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSpareDomainList(listingArr);
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === "asc") ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () => {
            const listingArr = this.fetchData();
            this.props.getSpareDomainList(listingArr);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    };

    deleteDomainHandler = (event, id) => {
        event.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t("global.confirm"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading()
                    }
                });

                const data = {};
                data.id = id;
                this.props.deleteSpareDomain(data);
            }
        });
    }

    actionFormatter = (cell, row) => {
        let deleteButton, output;

        if (this.state.permission.includes("spare_domain_update")) {
            deleteButton = (
                <Button
                    typeButton="button"
                    classValue="btn btn-sm btn-danger"
                    key={`delete-${row.id}`}
                    idValue={row.id === undefined ? 0 : row.id}
                    clicked={(event) => this.deleteDomainHandler(event, row.id)}
                    buttonName={<FontAwesomeIcon icon={faTrash} />}
                />
            );
        }

        output = [deleteButton];
        return output;
    }

    render() {
        const { t } = this.props;
        const columns = [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("spare-domain.domain"), dataField: "domain", sort: true, onSort: this.onSort },
            { text: t("spare-domain.type"), dataField: "type", sort: true, onSort: this.onSort },
            { text: t('spare-domain.created-at'), dataField: "created_at", sort: false },
            { text: t("global.action"), dataField: "#", formatter: this.actionFormatter, headerStyle: { width: "65px" } },
        ];

        let data = this.state.data.map((val, idx) => {
            let type = val.is_deposit === 1 ? t('spare-domain.deposit') : t('spare-domain.non-deposit');
            return {
                no: idx,
                id: val.id,
                domain: val.domain,
                type: type,
                created_at: val.created_at
            }
        });
        
        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <SpareDomainListing
                        filterInput={this.state.filterInput}
                        permission={this.state.permission}

                        changePageHandler={(page) => this.changePageHandler(page)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}

                        data={data}
                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}

                        loading={this.state.loading}
                    />
                )}

                {this.state.permission.includes("spare_domain_create") && this.state.pageShow === 'create' && (
                    <SpareDomainCreate
                        changePageHandler={(page) => this.changePageHandler(page)}
                        refreshHandler={() => this.refreshHandler()}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentPermission: state.currentUser.data.permission,
        spare_domain_list: state.spareDomain.spare_domain_list,
        spare_domain_delete: state.spareDomain.spare_domain_delete
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getSpareDomainList: (data) => dispatch(getSpareDomainList(data)),
        deleteSpareDomain: (data) => dispatch(deleteSpareDomain(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SpareDomain));